export default "__VITE_ASSET__dobHC$e2__"